import { Navigate, useLocation } from 'react-router-dom';
import { authUtils } from '@shared/utils/axios-instance';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const location = useLocation();
    const token = authUtils.getAccessToken();

    // Если нет токена, редиректим на логин
    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}

